import { HelpIcon, LoadingIcon } from '@bfe/moly-icons';
import clsx from 'clsx';
import { Tooltip, Image, Button, Spin } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { userLotteryStore } from '@/store/userLotteryStatusStore';
import { useUserLotteryStore } from '@/store/userLotteryStatusStore';
import { useRedemptionWallet } from '@/hooks/wallet';
import { useEffect } from 'react';
import {
  thousandsSeparator,
  publicAssetsPath,
  convertS3Url,
} from '@web3/base-utils';
import { SingleReward } from '@/services/lottery';
import { Page } from '@/config/track-config';
import { useConnectWalletModal } from '@web3fe/infra';

const bgUrl = publicAssetsPath('/png/home/redeemed-info-bg.png');

const url = convertS3Url(
  'https://s1.bycsi.com/bybit/deadpool/image-ff5077e00e9c47e1b214f58076f75e89.png'
);

export const RedeemedInfo = ({ className }: { className?: string }) => {
  const fm = useFm();

  return (
    <div
      className={clsx(className, 'pt-14 px-12')}
      style={{
        backgroundImage: `url(${bgUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
      }}
    >
      <div className="flex flex-col items-stretch gap-8 p-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="h4 mb-2">{fm('myRewards')}</div>
            <div className="regular-14">
              <span>{fm('pendingAirdrop')}</span>
              <Tooltip
                title={
                  <div className="max-w-[280px]">
                    <p>
                      {fm('airdropAndGasFeeNote', {
                        amount1: 30,
                        amount2: 0.1,
                      })}
                    </p>
                    <p>{fm('reviewActualRewards')}</p>
                  </div>
                }
              >
                <HelpIcon className="cursor-pointer inline-block ml-1" />
              </Tooltip>
            </div>
          </div>

          <div className="regular-12">{fm('yourTokenRewards')}</div>
        </div>

        <div className="h-[1px] bg-border"></div>

        <TokenRewardList />
      </div>
    </div>
  );
};

// const AirdropAmount = () => {
//   const {
//     isConnectedWallet,
//     isBybitWallet,
//     isPrivateKeyWallet,
//     wallet: { walletId, walletType },
//   } = useRedemptionWallet();
//   const { data, isLoading, error } = useUserLotteryStore();

//   useEffect(() => {
//     userLotteryStore.getState().getUserRewardStatus({ walletId, walletType });
//   }, []);

//   if (!isConnectedWallet) {
//     return '--';
//   }

//   if (!isBybitWallet) {
//     return '--';
//   }

//   if (isBybitWallet && isPrivateKeyWallet) {
//     return '0';
//   }

//   if (isLoading) {
//     return '--';
//   }

//   if (error) {
//     return '--';
//   }

//   return `${thousandsSeparator(Number(data?.rewardAmount))} ${data?.rewardToken}`;
// };

// TODO 还是需要定义各种情况下的展示内容

const TokenRewardList = () => {
  const {
    isConnectedWallet,
    isBybitWallet,
    wallet: { walletId, walletType },
  } = useRedemptionWallet();
  const { data, isLoading, error } = useUserLotteryStore();

  useEffect(() => {
    userLotteryStore.getState().getUserRewardStatus({ walletId, walletType });
  }, []);

  if (!isConnectedWallet || !isBybitWallet) {
    return <SecondConnectWalletButton />;
  }

  if (isLoading) {
    return (
      <Spin
        indicator={
          <LoadingIcon className="text-gray-t2 text-bds-font-size-h4 animate-spin !w-8 !h-8" />
        }
      ></Spin>
    );
  }

  if (error) {
    return <div className="text-[red]">ERROR please try again</div>;
  }

  return (
    <div className="grid grid-cols-4 gap-4">
      {data?.rewards.map((reward) => (
        <SingleTokenReward key={reward.rewardToken} token={reward} />
      ))}
    </div>
  );
};

const SingleTokenReward = ({ token }: { token: SingleReward }) => {
  return (
    <div className="flex items-center gap-5">
      <Image
        className={'w-8 h-8'}
        src={token.tokenIcon}
        alt={token.rewardToken}
      />
      <div className="flex flex-wrap items-baseline gap-2 min-w-0">
        <div
          className="h4 break-words min-w-0 bg-gradient-to-br from-[#FFD748] to-[#F7A600]"
          style={{
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            wordBreak: 'break-all',
          }}
        >
          <span className="inline-block">{token.rewardAmount}</span>
        </div>
        <div
          className="semibold-18 break-words min-w-0 bg-gradient-to-br from-[#FFD748] to-[#F7A600]"
          style={{
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          <span className="inline-block">{token.rewardToken}</span>
        </div>
      </div>
    </div>
  );
};

const SecondConnectWalletButton = () => {
  const connectWallet = useConnectWalletModal();
  const fm = useFm();

  return (
    <Button
      className="w-max !text-[#B176FF] border !border-[#B176FF]"
      data-spm-even="Web3UserClick"
      data-spm-data={JSON.stringify({
        page_name: Page.RewardsPage,
        button_name: 'Web3Points_ConnectWallet',
      })}
      onClick={() => connectWallet.show()}
      variant="secondary"
    >
      {fm('createWallet')}
    </Button>
  );
};
